import cn from 'classnames';
import { FunctionComponent, JSX } from 'preact';

import { BaseButton } from '../BaseButton/BaseButton';
import { useViewportType } from '../../hooks/useViewportType';

export interface IconButtonProps extends Omit<
  JSX.HTMLAttributes<HTMLButtonElement>,
  'size' | 'className'
> {
  size?: 'large' | 'medium' | 'small' | 'standard' | 'xsmall' | undefined;
  color?:
    | 'primary'
    | 'secondary'
    | 'accent'
    | 'transparent'
    | 'video-ui'
    | 'transparent-primary';
  variant?: 'circle' | 'rounded' | 'square';
  filled?: boolean;
  className?: Exclude<
    JSX.HTMLAttributes<HTMLButtonElement>['className'],
    JSX.SignalLike<any>
  >;
}

export const IconButton: FunctionComponent<IconButtonProps> = ({
  color = 'transparent',
  variant = 'rounded',
  size,
  children,
  filled,
  className,
  ...props
}) => {
  const { isMobile } = useViewportType();
  const buttonSize = size || (isMobile ? 'medium' : 'large');
  return (
    <BaseButton
      className={cn(
        'vgp-icon-button',
        `vgp-icon-button-size-${buttonSize}`,
        `vgp-icon-button-color-${color}`,
        `vgp-icon-button-variant-${variant}`,
        { 'vgp-icon-button-filled': filled },
        className
      )}
      {...props}
    >
      {children}
    </BaseButton>
  );
};
